/**
 * @generated SignedSource<<b99ecf1ec5d1b63eccde416063c23e71>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateAPIKeyInput = {
  description?: string | null | undefined;
  identity: string;
};
export type UpdateAPIKeyMutation$variables = {
  input: UpdateAPIKeyInput;
};
export type UpdateAPIKeyMutation$data = {
  readonly updateAPIKey: {
    readonly key: {
      readonly description: string;
      readonly id: string;
      readonly identity: string;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type UpdateAPIKeyMutation = {
  response: UpdateAPIKeyMutation$data;
  variables: UpdateAPIKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "APIKey",
  "kind": "LinkedField",
  "name": "key",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identity",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateAPIKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAPIKeyPayload",
        "kind": "LinkedField",
        "name": "updateAPIKey",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateAPIKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAPIKeyPayload",
        "kind": "LinkedField",
        "name": "updateAPIKey",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6a6072eed107d22cd45ff713a9d17b7",
    "id": null,
    "metadata": {},
    "name": "UpdateAPIKeyMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateAPIKeyMutation(\n  $input: UpdateAPIKeyInput!\n) {\n  updateAPIKey(input: $input) {\n    key {\n      description\n      id\n      identity\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "860fefa5d02642d1220c655d057aa377";

export default node;
